import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Footer } from '../components/Footer';
import { VslHeader } from '../components/VslHeader';
export function UpSellDisqualifyPage() {
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc] selection:text-black overflow-x-hidden" data-id="element-3236">
      <VslHeader data-id="element-3237" />

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60" data-id="element-3238">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-3239" />
      </div>

      <main className="relative z-10 max-w-3xl mx-auto px-4 flex flex-col items-center text-center min-h-[80vh] justify-center gap-6 md:gap-8" data-id="element-3240">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 px-4 py-1.5 rounded-full" data-id="element-3241">
          <span className="relative flex h-2 w-2" data-id="element-3242">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00f7fc] opacity-75" data-id="element-3243"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00f7fc]" data-id="element-3244"></span>
          </span>
          <span className="text-[#00f7fc] font-bold text-xs uppercase tracking-widest" data-id="element-3245">
            Aplicación en revisión
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight tracking-tight text-white" data-id="element-3246">
          Rompe el Ciclo de la Pobreza: La Diferencia entre Emprendimiento e
          Inversión
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-base md:text-lg text-gray-400 max-w-xl leading-relaxed" data-id="element-3247">
          Mientras revisamos tu aplicación, mira cómo funciona el sistema
          completo paso a paso, gratis, en YouTube.
        </motion.p>

        {/* CTA Button with pulse animation */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="w-full max-w-md mt-2" data-id="element-3248">
          <a href="https://www.youtube.com/watch?v=pDDEpxuxq3A&t=644s" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center gap-3 bg-gradient-to-b from-[#ef4444] to-[#dc2626] hover:from-[#f87171] hover:to-[#ef4444] text-white font-black text-base md:text-lg uppercase tracking-wide rounded-xl py-5 px-6 transition-all duration-300 transform hover:scale-[1.03]" style={{
          boxShadow: '0 0 20px rgba(239, 68, 68, 0.25), 0 0 40px rgba(239, 68, 68, 0.1)'
        }} data-id="element-3249">
            {/* Animated glow ring */}
            <span className="absolute inset-0 rounded-xl animate-pulse" style={{
            boxShadow: '0 0 25px rgba(239, 68, 68, 0.35), 0 0 50px rgba(239, 68, 68, 0.15)'
          }} data-id="element-3250" />

            <span className="relative z-10" data-id="element-3251">SIGUEME EN YOUTUBE</span>
            <ArrowRight className="relative z-10 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-3252" />

            {/* Shine sweep */}
            <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-3253">
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] animate-shine" data-id="element-3254" />
            </div>
          </a>
        </motion.div>
      </main>

      <Footer data-id="element-3255" />
    </div>;
}